import { Component, OnInit, Input, OnDestroy, ViewChild, TemplateRef } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { FormGroup } from '@angular/forms'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { AuthorizeService } from '../../service/authorize.service'
import { MatMenuTrigger } from '@angular/material';
import { ToastrService } from '../../../../node_modules/ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-additional-executive-summary',
  templateUrl: './additional-executive-summary.component.html',
  styleUrls: ['./additional-executive-summary.component.scss']
})
export class AdditionalExecutiveSummaryComponent implements OnInit, OnDestroy {
  @Input() printPage
  @Input() isFullFactSheet
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  isAdditionalExsum = true
  showTextWhenNull =
    'Capacity, Company History, Product Brand, Backlog project etc...'
  checkNulltext = false
  text
  checkDis = false
  checkModified = false
  comId
  newText
  secproData
  secproReturn = []
  checkUpdate = false
  form: FormGroup
  file: File
  subscription: Subscription
  isAE
  message
  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private authorization: AuthorizeService,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.isAE = response['ae']
        this.text = response['additionalInfo']
        this.comId = response['companyIdPsims']
        this.onChangeData()
      })
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  async onChangeData() {
    this.newText = this.text
  }

  modifiedText() {
    return (this.checkModified = true)
  }
  checkDisplay() {
    return (this.checkDis = true)
  }

  checkCancel() {
    this.newText = this.text
    return (this.checkUpdate = false), (this.checkDis = false)
  }

  checkSubmit() {
    this.text = this.newText
    this.updateToSecprofile()
    return (this.checkUpdate = true), (this.checkDis = false)
  }

  async updateToSecprofile() {
    const body = {
      companyId: this.comId,
      fieldName: 'additional',
      fieldValue: this.text
    }
    await this.cpmService.updateCompanyProfile(body).then(response => {
      this.message = response.status
      this.message === 'OK' ? (this.toastr.success('การบันทึกรายการสำเร็จแล้ว')) : (this.message = 'บันทึกรายการไม่สำเร็จ')
    },
      error => {
        this.message = 'บันทึกรายการไม่สำเร็จ'
        this.openModal(this.templateSaved)
      })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }
  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListAdditionalExesum')
      .removeClass('show')
  }
  closeModal() {
    this.modalRef.hide()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/additional-executive-summary/additional-executive-summary.component.ts